export default __webpack_public_path__ + "static/media/PubQuiz.f6cb6f6c.png";